<template>
  <div class="pledge-page">
    <UserInfoCard ref="userInfoCard" />
    <StakingForm
      :parent-address="parentAddress"
      :min-deposit="minDeposit"
      :submitting="submitting"
      @submit="onSubmit"
    />
    <PersonalInfo
      :info="personalInfo"
      :withdrawing-type="withdrawingType"
      :exchanging="exchanging"
      @withdraw="onWithdraw"
      @exchange="onExchange"
    />
    <StakingRecords
      :records="stakingRecords"
      :loading="loading"
      @redeem="onRedeem"
    />
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Notify } from "vant";
import UserInfoCard from "@/views/home/components/UserInfoCard.vue";
import StakingForm from "@/views/pledge/components/StakingForm.vue";
import StakingRecords from "@/views/pledge/components/StakingRecords.vue";
import PersonalInfo from "@/views/pledge/components/PersonalInfo.vue";
import { EMPTY_PERSONAL_INFO } from "@/views/pledge/config";
import {
  claimAllStakeRewards,
  claimCardsReward,
  claimPrincipal,
  claimShareReward,
  exchangeCard,
  fetchPersonalInfo,
  fetchStakingRecords,
  getMinDepositAmount,
  getParentAddress,
  resolveStakeParentAddress,
  stakeToken,
} from "@/contract/services/stakeService";
import { shouldNotifyRpcError } from "@/contract/index";

export default {
  name: "Pledge",
  components: {
    UserInfoCard,
    StakingForm,
    StakingRecords,
    PersonalInfo,
  },
  data() {
    return {
      loading: false,
      submitting: false,
      withdrawingType: "",
      exchanging: false,
      minDeposit: "",
      parentAddress: "",
      stakingRecords: [],
      personalInfo: { ...EMPTY_PERSONAL_INFO },
    };
  },
  computed: {
    ...mapGetters(["accountAddress"]),
  },
  watch: {
    accountAddress() {
      this.loadPageData();
    },
  },
  mounted() {
    this.loadPageData();
  },
  methods: {
    async loadPageData() {
      this.loading = true;
      try {
        this.minDeposit = await getMinDepositAmount();

        if (this.accountAddress) {
          const boundParent = await getParentAddress(this.accountAddress);
          this.parentAddress = resolveStakeParentAddress(boundParent);
          this.stakingRecords = await fetchStakingRecords(this.accountAddress);
          this.personalInfo = await fetchPersonalInfo(this.accountAddress);
        } else {
          this.parentAddress = resolveStakeParentAddress("");
          this.stakingRecords = [];
          this.personalInfo = { ...EMPTY_PERSONAL_INFO };
        }
        console.log(this.personalInfo,'pessss')
      } catch (err) {
        if (shouldNotifyRpcError(err)) {
          Notify({
            type: "danger",
            message: err?.message || "加载质押数据失败",
          });
        }
        throw err;
      } finally {
        this.loading = false;
      }
    },
    async onSubmit(data) {
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包" });
        return;
      }
      if (!data.amount || Number(data.amount) <= 0) {
        Notify({ type: "warning", message: "请输入有效的质押金额" });
        return;
      }
      if (Number(data.amount) < Number(this.minDeposit)) {
        Notify({
          type: "warning",
          message: `最小质押金额为 ${this.minDeposit} USDT`,
        });
        return;
      }

      const parent = this.parentAddress;

      this.submitting = true;
      try {
        await stakeToken(data.amount, data.duration, parent);
        Notify({ type: "success", message: "质押成功" });
        await this.loadPageData();
      } catch (err) {
        //
      } finally {
        this.submitting = false;
      }
    },
    async onRedeem(record) {
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包" });
        return;
      }
      if (!record.canRedeem) {
        return;
      }

      this.submitting = true;
      try {
        await claimPrincipal(record.index);
        Notify({ type: "success", message: "赎回成功" });
        await this.loadPageData();
      } catch (err) {
        //
      } finally {
        this.submitting = false;
      }
    },
    async onWithdraw(type) {
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包" });
        return;
      }

      this.withdrawingType = type;
      try {
        if (type === "staking") {
          await claimAllStakeRewards(this.accountAddress);
          Notify({ type: "success", message: "质押收益提取成功" });
        } else if (type === "promotion") {
          await claimShareReward();
          Notify({ type: "success", message: "推广权益提取成功" });
        } else if (type === "card") {
          await claimCardsReward();
          Notify({ type: "success", message: "卡牌收益提取成功" });
        }
        await this.loadPageData();
      } catch (err) {
        console.log(err);
        Notify({ type: "danger", message: "提取失败" });
        //
      } finally {
        this.withdrawingType = "";
      }
    },
    async onExchange(cardType) {
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包" });
        return;
      }

      this.exchanging = true;
      try {
        await exchangeCard(cardType);
        Notify({ type: "success", message: "卡牌兑换成功" });
        await this.loadPageData();
        await this.$refs.userInfoCard?.loadCardProfile();
      } catch (err) {
        //
      } finally {
        this.exchanging = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pledge-page {
  min-height: 100%;
  padding: 16px 0 20px;
}
</style>
